










































































































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import Survey from "@/components/beta/Settings/Surveys/Survey.vue";
import Search from "@/components/UI/Search.vue";
import BtnDefault from '@/components/UI/BtnDefault.vue';
import Modal from '@/components/UI/Modal.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import ICopy from '@/components/icons/ICopy.vue'
import IEdit from '@/components/icons/IEdit.vue'
import IArchive from '@/components/icons/IArchive.vue'
import IRestore from '@/components/icons/IRestore.vue'
import BtnDefaultToo from "@/components/UI/BtnDefaultToo.vue";
import api from "@/service/api";

const surveys = namespace('surveys')
const dialog = namespace('dialog')
const workspace = namespace('workspace')
const products = namespace('products')


@Component({
  name: 'Surveys',
  components: {
    BtnDefaultToo,
    Survey,
    Search,
    BtnDefault,
    Modal,
    Tooltip,
    ICopy,
    IEdit,
    IArchive,
    IRestore,
  }
})

export default class Surveys extends Vue {
  @surveys.Action('getSurveys') protected getSurveys:any
  @surveys.Action('createSurvey') protected createSurvey:any
  @surveys.Action('getSurvey') protected getSurvey:any
  @surveys.Action('editSurvey') protected editSurvey: any
  @surveys.Getter('surveys') protected surveys: any
  @surveys.Getter('survey') protected survey: any

  @products.Action('loadProductsFromServer') protected loadProductsFromServer: any
  @products.Getter('products') protected products: any


  @dialog.Mutation('SetFullPlanShow') protected SetFullPlanShow: any

  @workspace.Getter('getPlan') protected getPlan: any
  @workspace.Getter('getShow') protected getShow: any

  showModalImport: boolean = false

  showModalImportClose(){
    this.showModalImport = false
    this.currentExhibitionImport = null
    this.currentSurveyImport = null
    this.surveyImport = null
    this.errorImport = ''

  }

  search: string = ''
  isShowArchive: boolean = false
  loading: boolean = false
  selectSurvey: boolean = false
  openModal: boolean = false
  isShowLimitActive: boolean = false
  isShowChangeActive: boolean = false
  currentSurvey: any = {}

  currentExhibitionImport: string | null = null
  currentSurveyImport: number | null = null
  surveyImport: object[] | null = null
  errorImport: any = ''
  loadingImport: boolean = false

  get surveyImportNormalize(){
    if(!this.surveyImport) return []
    const dd =  this.surveyImport.map((el:any)=>{
      if(el.questions.filter((q:any)=>q.isProductAnswers === true).length){
        el.isProductAnswers = true
      }else {
        el.isProductAnswers = false
      }
     return el
    })
    return dd
  }

  async saveImport(){
    if(!this.surveyImportNormalize) return
    const show = this.getShow
    const survey:any = this.surveyImportNormalize.filter((el:any)=>el._id===this.currentSurveyImport)[0]
    survey.title = `${survey.title} [ импорт из ${show.filter((el:any)=>el.code === this.currentExhibitionImport )[0].title} ]`

   this.addSurveyImport(survey)
    this.showModalImport = false

  }

  checkExhibition(showCode: string) {
    this.currentExhibitionImport = showCode
    this.currentSurveyImport = null

    this.getSurveysImport()
  }

  checkSurvey(id: number) {
    this.currentSurveyImport = id
  }

  async getSurveysImport() {
    this.loadingImport = true

    try {
      const {data} = await api.go('getSurveys', {
        params: {
          showCode: this.currentExhibitionImport,
          CompanyCode: this.$route.params.code
        }
      })
      this.surveyImport = data.data.surveys
    } catch (e) {
      this.errorImport = this.$t('error.some_error.title')
    } finally {
      this.loadingImport = false
    }

  }

  get headers() {
    return [
      {text: '', sortable: false, value: 'isEdit', width: '68'},
      {text: this.$t('surveys.table.title'), sortable: true, value: 'title'},
      {text: this.$t('surveys.table.active'), sortable: false, value: 'isActive', width: "103"},
      {text: this.$t('surveys.table.questionsCount'), sortable: false, value: 'questionsCount', width: "128"},
      {text: this.$t('surveys.table.shardsCount'), sortable: true, value: 'countOfShards', width: "250"},
      {text: this.$t('surveys.table.updated'), sortable: true, value: 'updated', width: "250"},
      {text: this.$t('surveys.table.created'), sortable: true, value: 'created', width: "250"},
      {text: '', sortable: false, value: 'copy', width: '56'},
      {text: '', sortable: false, value: 'archive', width: '56'},
    ]
  }

  get surveysSearch() {
   if(this.search === '') return this.surveysArchive
    return this.surveysArchive.filter((el:any)=>{return el.title.toLowerCase().includes(this.search.toLocaleLowerCase())})
  }

  get surveysArchive() {
    if(this.isShowArchive) return this.surveys
    return this.surveys.filter((el:any) => {return !el.isArchived})
  }

  get countActive() {
    let count = 0
    this.surveys.forEach((survey:any) => {
      if(survey.isActive) count++
    });
    return count
  }

  async mounted() {
    this.loading = true
    await this.getSurveys({
      CompanyCode: this.$route.params.code,
      showCode: this.$route.params.showCode,
    })
    this.loading = false

    if (!this.products) {
      await this.loadProductsFromServer({
        params: {
          CompanyCode: this.$route.params.code,
          ShowCode: this.$route.params.showCode
        },
        query: {
          onlyOnShow: 1
        }

      })
    }

  }

  customSort(items:any, index:any, isDesc:any) {
    items.sort((a:any, b:any) => {
      if (index[0] === "updated") {
        if(!isDesc[0]) {
          return a.updatedAtTimestamp - b.updatedAtTimestamp;
        } else {
          return b.updatedAtTimestamp - a.updatedAtTimestamp;
        }
      } else if(index[0] === "created") {
        if(!isDesc[0]) {
          return a.createdAtTimestamp - b.createdAtTimestamp;
        } else {
          return b.createdAtTimestamp - a.createdAtTimestamp;
        }
      } else if(index[0] === "title") {
        if(!isDesc[0]) {
          return a.title.localeCompare(b.title);
        } else {
          return b.title.localeCompare(a.title);
        }
      } else if(index[0] === "countOfShards") {
        if(!isDesc[0]) {
          return a.countOfShards - b.countOfShards;
        } else {
          return b.countOfShards - a.countOfShards;
        }
      }
    });
    return items;
  }

  @Watch('$route', {immediate: true, deep: true})
  onUrlChange(old: any) {
    if (this.$route.query.id) {
      this.clickRowId(this.$route.query.id)
    } else {
      this.$router.push({path: this.$route.fullPath}).catch(() => {
      });
      this.selectSurvey = false
    }
  }

  async clickRowId(id:any) {
    this.$router.push({path: this.$route.fullPath, query: {id: id}}).catch(() => {
    });
    await this.getSurvey({
      surveyCode: id,
    })
    this.selectSurvey = true
  }

  async clickRow(item:any) {
    this.$router.push({path: this.$route.fullPath, query: {id: item._id}}).catch(() => {
    });
    await this.getSurvey({
      surveyCode: item._id,
    })
    this.selectSurvey = true
  }
  async addSurveyImport(survey:any) {
    await this.createSurvey({
      params: {
        CompanyCode: this.$route.params.code,
        showCode: this.$route.params.showCode,
      },
      body: survey
    })
    this.selectSurvey = true
  }

  async addSurvey() {
    await this.createSurvey({
      params: {
        CompanyCode: this.$route.params.code,
        showCode: this.$route.params.showCode,
      },
      body: {title: this.$t('surveys.new')}
    })
    this.selectSurvey = true
  }

  changeArchive() {
    this.isShowArchive = !this.isShowArchive
  }

  timeConverter(UNIX_timestamp: any) {
    if(UNIX_timestamp == 0) return ''
    const a = new Date(UNIX_timestamp * 1000);
    const months = ['янв', 'фев', 'март', 'апр', 'май', 'июнь', 'июль', 'авг', 'сен', 'окт', 'ноя', 'дек'];
    const year = a.getFullYear().toString().slice(-2);
    const month = this.dable(a.getMonth() + 1);
    const date = this.dable(a.getDate());
    const clock = this.dable(a.getHours())
    const min = this.dable(a.getMinutes())
    const rTime = clock + ':' + min
    const rDate = date + '.' + month + '.' + year;

    return {rDate, rTime};
  }

  dable(num: number) {
    return num < 10 ? '0' + num : num
  }

  showSurveys() {
    this.selectSurvey = false
    this.$router.replace({query: {
      'tab':'questionnaires'
      }});
  }

  showModal(item:any) {
    this.currentSurvey = item
    if(item.isArchived) {
      this.changeSurveyArchive()
    } else {
      this.openModal = true
    }
  }

  changeSurveyArchive() {
    this.editSurvey({
        params: {
            surveyCode: this.currentSurvey._id,
        },
        body: {
          isArchived: !this.currentSurvey.isArchived
        }
    })
    this.openModal = false
  }

  async copy(item:any) {
    await this.getSurvey({
      surveyCode: item._id,
    })
    await this.createSurvey({
      params: {
        CompanyCode: this.$route.params.code,
        showCode: this.$route.params.showCode,
      },
      body: {
        title: this.$t('surveys.copy') + ' ' + this.survey.title,
        questions: this.survey.questions,
        hasSignature: this.survey.hasSignature,
        isArchived: false,
        isActive: false,
      }
    })
    this.selectSurvey = true
  }

  checkActive(item:any) {
    // if(this.getPlan != 'pro' && this.countActive > 0) {
    //   this.isShowLimitActive = true
    // } else {
      this.changeActive(item)
    // }
  }
  
  changeActive(item:any) {
    this.editSurvey({
      params: {
        surveyCode: item._id,
      },
      body: {
        isActive: !item.isActive
      }
    })
  }

  showPlans() {
    this.isShowLimitActive = false
    this.SetFullPlanShow(true)
  }
}
